import { render } from "./HomeStaffInfo.vue?vue&type=template&id=66f315e2&scoped=true"
import script from "./HomeStaffInfo.vue?vue&type=script&lang=js"
export * from "./HomeStaffInfo.vue?vue&type=script&lang=js"

import "./HomeStaffInfo.vue?vue&type=style&index=0&id=66f315e2&scoped=true&lang=css"

import exportComponent from "D:\\eazyc\\ezDev\\ECS-Cognitive\\cognitive-screening-mobile-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66f315e2"]])

export default __exports__